import React from "react";
import { Select } from "antd";
import groupedExams from "../../../../utils/groupedExams.json";

const { Option, OptGroup } = Select;

const groupableExamTypes = ['laboratory'];

const normalizeText = (text) => (text || "")
  .normalize("NFD")
  .replace(/[̀-ͯ]/g, "")
  .toLowerCase();

export const getExamOptionLabel = (examOption) => examOption.exam ? examOption?.exam?.name : examOption?.groupTitle;

export const areAllExamsSelected = (exams, selectedExamIds) => exams.every((exam) => selectedExamIds.includes(exam.exam_id));

export const buildExamOptions = (exams, shouldGroupExams) => {
  const availableExams = exams || [];
  if (!shouldGroupExams) {
    return availableExams.map((exam) => ({ exam }));
  }
  const groupOptions = groupableExamTypes
    .map((groupType) => ({
      groupType,
      groupTitle: groupedExams[groupType],
      groupExams: availableExams.filter((exam) => exam.exam_type === groupType),
    }))
    .filter((groupOption) => groupOption.groupExams.length > 0);
  const groupedTypes = groupOptions.map((groupOption) => groupOption.groupType);
  const ungroupedExamOptions = availableExams
    .filter((exam) => !groupedTypes.includes(exam.exam_type))
    .map((exam) => ({ exam }));
  return [...groupOptions, ...ungroupedExamOptions]
    .sort((optionA, optionB) => (getExamOptionLabel(optionA) || "").localeCompare(getExamOptionLabel(optionB) || ""));
};

export const toggleGroupExamIds = (selectedExamIds, groupExams) => {
  const groupExamIds = groupExams.map((exam) => exam.exam_id);
  return areAllExamsSelected(groupExams, selectedExamIds)
    ? selectedExamIds.filter((examId) => !groupExamIds.includes(examId))
    : [...selectedExamIds, ...groupExamIds.filter((examId) => !selectedExamIds.includes(examId))];
};

export const filterExamOption = (input, option) => {
  const optionLabel = typeof option?.children === "string" ? option.children : option?.title;
  return normalizeText(optionLabel).includes(normalizeText(input));
};

const renderExamOption = (exam) => (
  <Option key={exam.exam_id} value={exam.exam_id}>
    {exam.name}
  </Option>
);

export const renderExamOptions = ({ examOptions, selectedExamIds, onGroupTitleClick }) => examOptions.map((examOption) => {
  if (examOption.exam) return renderExamOption(examOption.exam);
  return (
    <OptGroup
      key={examOption.groupType}
      title={examOption.groupTitle}
      label={
        <span
          className={`exam-group-title${areAllExamsSelected(examOption.groupExams, selectedExamIds) ? ' selected' : ''}`}
          onClick={() => onGroupTitleClick(examOption.groupExams)}
        >
          {examOption.groupTitle}
        </span>
      }
    >
      {examOption.groupExams.map(renderExamOption)}
    </OptGroup>
  );
});
